import { NavigateFunction } from "react-router-dom";
import { routesConfig } from "../App";

// This function checks if a given stored route matches any of the valid routes
// by splitting both the stored route and valid routes into segments and comparing them.
// If a segment is dynamic (e.g., ":id"), it will be accepted. It returns true if any
// valid route matches the stored route, otherwise false.
export function isValidRoute(storedRoute?: string, validRoutes?: string[]) {
  const storedSegments = storedRoute?.split("/")?.filter(Boolean);

  return validRoutes?.some((route) => {
    const validSegments = route.split("/").filter(Boolean);

    if (storedSegments?.length !== validSegments.length) {
      return false;
    }

    for (let i = 0; i < validSegments.length; i++) {
      if (validSegments[i].startsWith(":")) {
        continue;
      }

      if (storedSegments?.length && storedSegments[i] !== validSegments[i]) {
        return false;
      }
    }

    return true;
  });
}

// This function handles redirection based on certain conditions. It first checks if there
// is a valid previous path stored in the location state. If it exists and is not a 404 page,
// it navigates back. If there's no valid previous path,it redirects the user to the login page.
export const handleRedirect = (navigate: NavigateFunction, location: any) => {
  const validRoutes = routesConfig?.map((route) => route.path);
  const previousPath = location?.state?.from;

  if (
    previousPath &&
    previousPath !== "/page-not-found" &&
    isValidRoute(previousPath, validRoutes)
  ) {
    navigate(-1);
  } else {
    // TODO: change by home/admin if user is logged when this view and services are implemented
    navigate("/login", { replace: true });
  }
};
